import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
const before = ['Prepari separatamente spiegazioni, esercizi, attività e verifiche.', 'I tuoi materiali sono distribuiti tra cartelle, libri, file e piattaforme diverse.', 'I concetti astratti richiedono molto tempo per essere spiegati senza rappresentazioni visuali.', 'Ogni nuova unità ti costringe a ricominciare la pianificazione quasi da capo.', 'Devi adattare continuamente risorse che non fanno parte di un percorso coerente.'];
const after = ['Risparmi ore di preparazione ogni settimana.', 'Spieghi i concetti astratti attraverso rappresentazioni visuali chiare.', 'Utilizzi schede, attività, laboratori, verifiche e soluzioni già pronti.', 'Mantieni continuità tra un argomento e quello successivo.', 'Adatti le risorse al lavoro individuale, di gruppo, al ripasso, al recupero o alla valutazione.', 'Entri in classe con un percorso ordinato e professionale.'];
export function PainSection() {
  return <section className="w-full bg-paper px-5 py-12 sm:py-20" data-id="element-132" data-mp="3rlfzhv9qnb9b">
      <div className="mx-auto max-w-5xl" data-id="element-133" data-mp="3nm75qqep7ddr">
        <div className="mx-auto max-w-2xl text-center" data-id="element-134" data-mp="3nl5vgo5iaux3">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-135" data-mp="5g2k4loy5mo8">
            Smetti di passare le serate a creare materiali di chimica da zero.
          </h2>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-136" data-mp="38xkrks0t4ro4">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5
        }} className="rounded-2xl border-l-4 border-red-300 bg-[#FFF5F5] p-6 sm:p-8" data-id="element-137" data-mp="33xg9wyo5xqwb">
            <h3 className="mb-5 text-lg font-bold text-ink sm:text-xl" data-id="element-138" data-mp="2q61n0gr4x5jz">Il problema</h3>
            <ul className="space-y-3" data-id="element-139" data-mp="2q3oz7myp40z0">
              {before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-140" data-mp="2l6otxe9o728y">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-500" data-id="element-141" data-mp="p2r5vqhbfcui">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-142" data-mp="u12anmsr6x5v" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-143" data-mp="yueyvvtit1y3">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="rounded-2xl border-l-4 border-cobalt bg-[#EEF4FF] p-6 sm:p-8" data-id="element-144" data-mp="65pyjz0ah0ne">
            <h3 className="mb-5 text-lg font-bold text-cobalt-deep sm:text-xl" data-id="element-145" data-mp="k5ii9adeeglv">
              Con CHIMICA VISIVA™
            </h3>
            <ul className="space-y-3" data-id="element-146" data-mp="1qmvwjuc3fb61">
              {after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-147" data-mp="1vib8uhugcz0c">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cobalt/15 text-cobalt-deep" data-id="element-148" data-mp="25o2rb7pn5hto">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-149" data-mp="20phznwogg6gu" />
                  </span>
                  <span className="text-sm leading-relaxed text-ink/80" data-id="element-150" data-mp="1vw6tzyvdpvqi">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}